import { NgIf } from '@angular/common';
import { Component, HostBinding, Input, Optional } from '@angular/core';

@Component({
  selector: 'app-loading-btn',
  standalone: true,
  imports: [
    NgIf
  ],
  styles: [`
    .button-disabled {
      cursor: not-allowed;
    }
  `],
  template: `
    <button [disabled]="isLoading || disabled" [class]="className" (click)="clickAction?.()" [type]="clickAction ? 'button' : 'submit'">
      <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      {{ buttonText }}
      <ng-content></ng-content>
    </button>
  `,
})
export class LoadingBtnComponent {

  @Input() isLoading: boolean = false;
  @Input() disabled: boolean = false;
  @Input() btnName: string = '';
  @Input() className: string = 'w-100 btn btn-lg btn-primary';
  @Input() @Optional() clickAction: (() => void) | null = null;

  @HostBinding('class.button-disabled') isButtonDisabled = false;

  buttonText = this.btnName;

  ngOnChanges(): void {
    this.isButtonDisabled = this.isLoading;
    this.buttonText = this.isLoading ? 'Loading...' : this.btnName;
  }
}
